import React from "react";
import PropTypes from "prop-types";
import { 
    OrderedMap, 
    List
} from "immutable";
import moment from "moment";
import { 
    Card, 
    // Popconfirm,
    Tag, 
    Select,
    Icon,
    Modal,
    message, Checkbox, Button, Upload } from "antd";
import { Table } from "components";
import { STATE_STATUS } from "constants";
import { LEDGER_DATA_SOURCE } from "constants/enums";
import UnderwritingService from "services/underwriting-service";
import { fetchCaseLedgerMasters }  from "services/case-service";
import CaseService from "services/case-service";
import { ellipsisText } from "components/ellipsis-text";

const  { Dragger } = Upload;

const base64ToArrayBuffer = data => {
    try {
        var input = data.substring(data.indexOf(",") + 1);
        var binaryString = window.atob(input);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    } catch(err) {
        console.error(err.message);
    }
};

const downloadFileLocally = (res, fileType, type) => {
    var blob = new Blob([res], { type: type });
    var elem = window.document.createElement("a");
    elem.href = window.URL.createObjectURL(blob);
    elem.download = `ledger.${fileType}`;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
};


window.downloadFileLocally = downloadFileLocally;

const downloadPaymentStatus = (disabled, supplychain_id) => {
    const download = () => {
        message.loading("File Download in progress, may take few seconds... ", 0);
        UnderwritingService.getLedgerFile(supplychain_id, true, true).then(_ => {
            message.destroy();
            if(_.error){
                throw _.error;
            } else {
                if(_.data && _.data.ok) {
                    const data = base64ToArrayBuffer(_.data && _.data.ok);
                    downloadFileLocally(data, "xlsx");
                } else if(_.data && _.data.zip) {
                    const data = base64ToArrayBuffer(_.data && _.data.zip);
                    downloadFileLocally(data, "zip");
                }
            }
        }).catch(() => {
            message.destroy();
            message.error("Failed to Download File");
        });
    };
    return (
        <Button disabled={disabled} onClick={download} type={"link"} size={"small"}>
            {"Download"}
        </Button>
    );
};

const downloadFile = (disabled, supplychain_id) => {
    return(<Button disabled={disabled} type={"link"} size={"small"} onClick={() => UnderwritingService.getLedgerFile(supplychain_id,false,false,"pdf").then(_ => {
        message.destroy();
        if(_.data && _.headers["content-type"] == "application/pdf") {
            downloadFileLocally(_.data, "pdf", "application/pdf");
        } else if(_.data && _.headers["content-type"] == "application/zip") {
            downloadFileLocally(_.data, "zip", "application/zip");
        }
    }).catch(() => {
        message.destroy();
        message.error("Failed to Download File");
    })}>
        {"Download"}
    </Button>);
    // return (
    //     <Popconfirm
    //         title={"Which type of file you want to download ?"}
    //         okText={"Excel"}
    //         cancelText={"Pdf"}
    //         onConfirm={() => {
    //             message.loading("File Download in progress, may take few seconds... ", 0);
    //             UnderwritingService.getLedgerFile(supplychain_id, true).then(_ => {
    //                 message.destroy();
    //                 if(_.data) {
    //                     downloadFileLocally(_.data, "xlsx", "application/vnd.ms-excel");
    //                 }
    //             }).catch(() => {
    //                 message.destroy();
    //                 message.error("Failed to Download File");
    //             });
    //         }}
    //         onCancel={() => {
    //             message.loading("File Download in progress, may take few seconds... ", 0);
    //             UnderwritingService.getLedgerFile(supplychain_id, false).then(_ => {
    //                 message.destroy();
    //                 if(_.data) {
    //                     downloadFileLocally(_.data, "pdf", "application/pdf");
    //                 }
    //             }).catch(() => {
    //                 message.destroy();
    //                 message.error("Failed to Download File");
    //             });
    //         }}
    //     >
            
    //     </Popconfirm>
    // );
};

const SUPPLY_CHAIN_COLS = new OrderedMap({
    ledger: {
        title: "Ledger",
        dataIndex: "name",
        key: "ledger",
        width: 250,
        align: "center"
    },
    seller: {
        title: "Seller",
        dataIndex: "seller",
        key: "seller",
        width: 300,
        render: _ => _ && ellipsisText(`${_.name}(${_.gstin})`),
        align: "center",
    },
    date_of_analyses: {
        title: "Analysed On",
        dataIndex: "create_date",
        key: "create_date",
        render: _ => moment(_).format("DD MMM YY"),
        width: 150,
        align: "center"
    },
    last_sync_date: {
        title: "Last Sync Date",
        dataIndex: "last_sync_date",
        key: "last_sync_date",
        render: _ => _ ? moment(_).format("DD MMM YY") : " -- ",
        width: 150,
        align: "center"
    },
    data_source_type: {
        title: "Data Source Type",
        dataIndex: "data_source_type",
        key: "data_source_type",
        width: 200,
        align: "center",
        render: _ => LEDGER_DATA_SOURCE.findKey(__ => __ == _)
    },
    date_of_appointment: {
        title: "Date of Appointment With Anchor",
        dataIndex: "date_of_appointment",
        key: "date_of_appointment",
        render: _ => _ && moment(_).format("DD MMM YY"),
        width: 200,
        align: "center"
    },
    avg_repayment_period: {
        title: "Avg Repayment Period",
        dataIndex: "avg_repayment_period",
        key: "avg_repayment_period",
        width: 200,
        align: "center",
        render: _ => _ || "N/A"
    },
    future_dated_debit_amount: {
        title: "Future Dated Debit Amount",
        dataIndex: "future_dated_debit_amount",
        key: "future_dated_debit_amount",
        width: 200,
        align: "center"
    },
    future_dated_credit_amount: {
        title: "Future Dated Credit Amount",
        dataIndex: "future_dated_credit_amount",
        key: "future_dated_credit_amount",
        width: 200,
        align: "center"
    },
    net_sales_amount_last_12_months: {
        title: "Net Sales(Last 12 months)",
        dataIndex: "ledger_analysis.net_sales_amount_last_12_months",
        key: "net_sales_amount_last_12_months",
        width: 200,
        align: "center"
    },
    // tenor: {
    //     title: "Tenor",
    //     dataIndex: "tenor",
    //     key: "tenor",
    //     width: 100,
    //     align: "center"
    // },
    proposed_limit: {
        title: "Limit",
        dataIndex: "ledger_analysis.limit_basis_sales",
        key: "proposed_limit",
        width: 100,
        align: "center"
    },
    score: {
        title: "Score",
        dataIndex: "score",
        key: "score",
        render: (_, record) => record.score_obtained ? `${record.score_obtained}/${record.max_score}` : "--",
        width: 100,
        align: "center"
    },
    system_recommendation: {
        title: "System Recommendation",
        dataIndex: "system_recommendation",
        key: "system_recommendation",
        width: 200,
        align: "center"
    },
    remarks: {
        title: "Remarks",
        dataIndex: "ledger_analysis.remarks",
        key: "remarks",
        width: 200,
        align: "center"
    },
    download_file: {
        title: "Download Ledger",
        dataIndex: "download_file",
        key: "download_file",
        width: 100,
        align: "center"
    },
    // download_payment_status: {
    //     title: "Payment Status",
    //     dataIndex: "download_payment_status",
    //     key: "download_payment_status",
    //     width: 100,
    //     align: "center"
    // }
});

class LedgerMasterData extends React.Component {

    state = {
        ledger_masters: null,
        gstin: null,
        fileList: [],
        openModal: false,
        ledgerUploading: false,
        distributorsList: [],
        selectedDsitributor: null,
        caseLedgerStatus: null,
    };

    componentDidMount() {
        this.fetchLedgerMastersAndGSTIN();
        this.fetchDistributorList();
        CaseService.getCaseLedgerStatus(this.props.caseId).then(({ data }) => {
            this.setState({
                caseLedgerStatus: data.status,
                tagFromDate: data.supplychain_filter_from_date,
                tagToDate: data.supplychain_filter_to_date
            });
        });
    }

    fetchDistributorList = () => {
        CaseService.getCaseSellers(this.props.caseId).then(({ data }) => {
            this.setState({
                distributorsList: data.sellers
            });
        });
    }

    toggleUploadModal = () => {
        this.setState({
            openModal: !this.state.openModal
        });
    }

    fetchLedgerMastersAndGSTIN() {
        const  { company, caseDetail } = this.props;
        this.setState({
            status: STATE_STATUS.FETCHING
        }, async () => {
            const { data: ledger_masters } = await fetchCaseLedgerMasters(caseDetail.id);
            const { data: gstin_ledger_masters } = await UnderwritingService.getSupplyChainListByGSTIN(company.gstin);
            // const { data, error } = await CompanyService.parseGSTIN(company.gstin);
            gstin_ledger_masters.map(_ => {
                if(!ledger_masters.find(__ => __.ledger_analysis && __.ledger_analysis.id === _.id || _.id === __.id)) {
                    ledger_masters.push({ ..._, checked: false });
                }
            });
            this.setState({
                status: STATE_STATUS.FETCHED,
                ledger_masters: ledger_masters.map(_ => {
                    let gstin_ledger = gstin_ledger_masters.find(__ => _.id == __.id || (_.ledger_analysis && _.ledger_analysis.id == __.id));
                    if(gstin_ledger) {
                        return {
                            ..._,
                            last_sync_date: gstin_ledger.last_sync_date,
                            data_source_type: gstin_ledger.data_source_type,
                            future_dated_credit_amount: gstin_ledger.future_dated_credit_amount,
                            future_dated_debit_amount: gstin_ledger.future_dated_debit_amount,
                            avg_repayment_period: _.avg_repayment_period || gstin_ledger.avg_repayment_period
                        };
                    }
                    return _;
                })
            });
        });
        
    }

    updateGSTINRelatedFields = () => {
        if(this.state.gstin) {
            UnderwritingService.getSupplyChainListByGSTIN(this.props.gstin).then(({ data }) => {
                if(data && data.length > 0) {
                    this.setState({
                        ledger_masters:data,
                    });
                }
            });
        }
    }

    getLedgerMasterLimit = (ledger_masters) => {
        try {
            const ledgerMasterLimit = (ledger_masters || []).filter(_ => _.checked).reduce((limit, _) => limit + (_.ledger_analysis && +_.ledger_analysis.limit_basis_sales), 0);
            return ledgerMasterLimit || 0;
        } catch(error) {
            return 0;
        }
    }

    tableCols = new OrderedMap({
        "checked": {
            title: "",
            dataIndex: "checked",
            key: "checked",
            width: 50,
            disabled: true,
            render: (_) => <Checkbox className={"px-5"} checked={_ === false ? _ : true}/>
        }
    }).merge(SUPPLY_CHAIN_COLS);

    uploadLedgers = () => {
        const fileList = this.files;
        let data = new FormData();
        data.append("seller_id", this.state.selectedDsitributor);
        fileList.map(_ => data.append("files", _));
        data.append("case_id", this.props.caseId);
        CaseService.uploadCaseLedgers(data).then(() => {
            message.success("Ledgers Request has been created");
            this.setState({
                ledgerUploading: false
            }, () => this.toggleUploadModal());
            
        }).catch(() => {
            message.error("Failed to create Request");
            this.setState({
                ledgerUploading: false
            });
        });
    }

    onChangeFileList = (file) => {
        this.files = [
            ...this.files,
            file
        ];
    }

    files = [];

    updateSelectedDistributor = (id) => {
        this.setState({
            selectedDsitributor: id
        });
    }

    render() {
        return (
            <React.Fragment>
                <Modal
                    title={"Upload Ledger form"}
                    visible={this.state.openModal}
                    footer={null}
                    closable={true}
                    onCancel={this.toggleUploadModal}
                >
                    <div className={"p-10"}>
                        <Select
                            style={{
                                width: "100%"
                            }}
                            placeholder={"Select Distributor"}
                            className={"mb-5"}
                            value={this.state.selectedDsitributor}
                            onSelect={this.updateSelectedDistributor}
                        >
                            {this.state.distributorsList.map(_ => (
                                <Select.Option key={_.id} value={_.id}>
                                    {`${_.name} | ${_.gstin}`}
                                </Select.Option>
                            ))}
                        </Select>
                        <Dragger
                            name={"file"}
                            multiple={true}
                            action={null}
                            beforeUpload={(file) => this.onChangeFileList(file)}
                            showUploadList={true}
                            disabled={this.props.recreditViewOnlyPermission}
                        
                        >
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            {/* <p className="ant-upload-hint">
                                Max file size is 20 MB
                            </p> */}
                        </Dragger>
                        <Button
                            className={"mt-10"}
                            onClick={() => this.setState({
                                ledgerUploading: true
                            }, () => this.uploadLedgers())} 
                            block
                            loading={this.state.ledgerUploading}
                            type={"primary"}
                            disabled={this.props.recreditViewOnlyPermission}
                        >
                            {"Upload"}
                        </Button>
                    </div>
                    
                </Modal>
                <Card
                    className={"padless-card small-card-title"}
                    title={"Ledger Analysis"}
                    extra={[
                        <Tag key={"ledger-status"} color="cyan">{this.state.caseLedgerStatus}</Tag>,
                        <Button
                            onClick={this.toggleUploadModal}
                            key={"upload"}
                            type={"link"}
                            disabled={this.props.recreditViewOnlyPermission}
                        >
                            {"Upload Incremental Ledgers"}
                        </Button>
                    ]}
                >
                    <Table
                        columns={this.tableCols}
                        data={this.state.ledger_masters ? new List(this.state.ledger_masters && this.state.ledger_masters.map(_ => {
                            let row = _;
                            if(!row.ledger_analysis || (row.ledger_analysis && !row.ledger_analysis.id)) {
                                row.download_file = downloadFile.bind(null, true,  _.supplychain_id)();
                                row.download_payment_status = downloadPaymentStatus.bind(null, true, _.supplychain_id)();
                                return row;
                            }
                            row.download_file = downloadFile.bind(null, false,  _.supplychain_id)();
                            row.download_payment_status = downloadPaymentStatus.bind(null, false, _.supplychain_id)();
                            return row;
                        })) : new List([])}
                        showTopSection={false}
                        noRowSelection={true}
                        // className={"inbox-table"}
                    />
                </Card>
            </React.Fragment>
        );
    }

}

LedgerMasterData.propTypes = {
    gstin: PropTypes.string,
    company: PropTypes.object,
    caseDetail: PropTypes.object,
    caseId: PropTypes.number,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default LedgerMasterData;
